// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import {
  formatDollarsForDisplay,
  formatCentsAsDollars,
  parseDollarsToCents,
} from 'bench-internal-theme';
import TextInput from './TextInput';

const styleTypeColors = {
  credit: colors.copper,
  debit: colors.bonsai,
};

const CurrencyDisplayInput = styled(TextInput)`
  ${({ styleType }) =>
    styleTypeColors[styleType] &&
    `
    color: ${styleTypeColors[styleType]};
      ::placeholder {
        color: ${styleTypeColors[styleType]};
      }
  `};
  text-align: right;
`;

type CurrencyInputProps = {
  defaultValueInCents?: number,
  errorText: ?string,
  name?: string,
  onBlur?: (event: any) => void,
  onChange?: (event: any) => void,
  onFocus?: (event: any) => void,
  styleType?: 'debit' | 'credit',
};

type CurrencyInputState = {
  amountInDollars: string,
  isFocused: boolean,
};

class CurrencyInput extends Component<CurrencyInputProps, CurrencyInputState> {
  static defaultProps = {
    defaultValueInCents: undefined,
    name: undefined,
    onBlur: undefined,
    onChange: undefined,
    onFocus: undefined,
    styleType: undefined,
  };

  constructor(props: CurrencyInputProps) {
    super(props);
    this.state = {
      amountInDollars: props.defaultValueInCents
        ? formatCentsAsDollars(props.defaultValueInCents)
        : '',
      isFocused: false,
    };
  }

  handleBlur = (blurEvent: any) => {
    this.setState({
      isFocused: false,
    });

    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(blurEvent);
    }
  };

  handleChange = (changeEvent: any) => {
    const inputValue = changeEvent.target.value;
    const amountInCents = parseDollarsToCents(inputValue);
    this.setState({ amountInDollars: inputValue });

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(amountInCents);
    }
  };

  handleFocus = (focusEvent: any) => {
    const inputElement = focusEvent.target;
    this.setState({ isFocused: true }, () => {
      inputElement.select();
    });

    if (typeof this.props.onFocus === 'function') {
      this.props.onFocus(focusEvent);
    }
  };

  render() {
    const { name, errorText, styleType, ...props } = this.props;
    const { amountInDollars, isFocused } = this.state;

    return (
      <CurrencyDisplayInput
        errorText={errorText}
        styleType={styleType}
        step=".01"
        {...props}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        type={isFocused ? 'number' : 'text'}
        value={isFocused ? amountInDollars : formatDollarsForDisplay(amountInDollars)}
      />
    );
  }
}

export default CurrencyInput;
